/**
 * User administration API (superadmin only).
 * Talks to the /admin/users endpoints via the shared axios client (which
 * attaches the Cognito id token and handles 401 centrally).
 */
import apiClient from './client';

export type UserRole = 'superadmin' | 'admin' | 'author' | 'reader';

export const USER_ROLES: UserRole[] = ['superadmin', 'admin', 'author', 'reader'];

export interface ManagedUser {
  username: string;
  email: string | null;
  status: string | null;
  enabled: boolean;
  role: string;
}

export async function listUsers(): Promise<ManagedUser[]> {
  const res = await apiClient.get('/admin/users');
  return res.data?.users || [];
}

export async function createUser(email: string, role: UserRole): Promise<void> {
  await apiClient.post('/admin/users', { email, role });
}

export async function setUserRole(email: string, role: UserRole): Promise<void> {
  await apiClient.patch(`/admin/users/${encodeURIComponent(email)}/role`, { role });
}

export async function setUserEnabled(email: string, enabled: boolean): Promise<void> {
  await apiClient.post(`/admin/users/${encodeURIComponent(email)}/${enabled ? 'enable' : 'disable'}`);
}

export async function resetUserPassword(email: string): Promise<void> {
  await apiClient.post(`/admin/users/${encodeURIComponent(email)}/reset-password`);
}

export async function deleteUser(email: string): Promise<void> {
  await apiClient.delete(`/admin/users/${encodeURIComponent(email)}`);
}
